import { create } from 'zustand';

export type NewMessagesBoundaryEntry =
  | { kind: 'anchor'; anchor: string }
  | { kind: 'snapshot'; latestMessageTimestamp: string | null; leftAt: number };

interface NewMessagesBoundaryStoreState {
  entries: Record<string, NewMessagesBoundaryEntry>;
  setEntry: (conversationId: string, entry: NewMessagesBoundaryEntry) => void;
  clearEntry: (conversationId: string) => void;
}

// Deliberately not persisted: this survives route navigation, but a reload starts clean.
export const useNewMessagesBoundaryStore = create<NewMessagesBoundaryStoreState>()((set) => ({
  entries: {},
  setEntry: (conversationId, entry) =>
    set((state) => ({ entries: { ...state.entries, [conversationId]: entry } })),
  clearEntry: (conversationId) =>
    set((state) => {
      if (!(conversationId in state.entries)) return state;

      const entries = { ...state.entries };
      delete entries[conversationId];
      return { entries };
    }),
}));
